import { configureRequest, replacePathVariables } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  UpdateTripDetailsForAdminErrorResponse,
  UpdateTripDetailsForAdminRequest,
  UpdateTripDetailsForAdminSuccessResponse
} from './updateTripDetailsForAdmin.types'

export const updateTripDetailsForAdminApi = async (
  request: UpdateTripDetailsForAdminRequest
): Promise<UpdateTripDetailsForAdminSuccessResponse> => {
  const { flightItineraryId, ...updateData } = request

  const response = await configureRequest({
    url: replacePathVariables(urls.admin.updateTripDetailsForAdmin, {
      flightItineraryId
    }),
    method: 'PUT',
    data: updateData,
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as UpdateTripDetailsForAdminSuccessResponse
  } else {
    throw response as UpdateTripDetailsForAdminErrorResponse
  }
}

export default updateTripDetailsForAdminApi
